// extracted by mini-css-extract-plugin
export default {"brandPromo":"xF-z","carousel":"yF-z"};